import { useTranslation } from "react-i18next";
import useAnimateCss from "../../hooks/useAnimateCss";
import sideImg1 from "../../assets/images/misc/man-with-steel.jpg";
import sideImg2 from "../../assets/images/misc/billet.jpg";
import sideImg3 from "../../assets/images/misc/steel-rebar-2.webp";
import sideImg4 from "../../assets/images/misc/men-in-location.jpg";

function BottomCtaBanner() {
  const { t } = useTranslation();
  const sectionRef = useAnimateCss("animate__fadeIn",    0,   0.1, 1000);
  const labelRef   = useAnimateCss("animate__fadeInDown",200, 0.1);
  const headRef    = useAnimateCss("animate__zoomIn",    380, 0.1, 800);
  const text1Ref   = useAnimateCss("animate__fadeInUp",  520, 0.1);
  const text2Ref   = useAnimateCss("animate__fadeInUp",  640, 0.1);

  return (
    <section className="bottom-banner-red" ref={sectionRef as any}>
      {/* 4 absolutely-positioned corner images — keep existing CSS slide-in */}
      <img src={sideImg1} alt="" className="bbanner-img bbanner-img--tl" />
      <img src={sideImg2} alt="" className="bbanner-img bbanner-img--bl" />
      <img src={sideImg3} alt="" className="bbanner-img bbanner-img--tr" />
      <img src={sideImg4} alt="" className="bbanner-img bbanner-img--br" />

      {/* Center content */}
      <div className="bbanner-center">
        <span className="banner-red-label" ref={labelRef as any}>{t("bottom-banner-label")}</span>
        <h2 className="banner-red-heading" ref={headRef as any}>{t("bottom-banner-headline")}</h2>
        <p className="banner-red-text" ref={text1Ref as any}>{t("bottom-banner-text")}</p>
        <p className="banner-red-text mt-2" ref={text2Ref as any}>{t("bottom-banner-text2")}</p>
      </div>
    </section>
  );
}

export default BottomCtaBanner;
